import {
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO,
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL,
  ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS,
  GET_ALL_QUOTES_FAIL,
  GET_ALL_QUOTES_SUCCESS,
  GET_BY_ID_QUOTES_SUCCESS,
  GET_BY_ID_QUOTES_FAIL,
  DELETE_QUOTES,
  DELETE_QUOTES_SUCCESS,
  DELETE_QUOTES_FAIL,
  QUOTE_STATUS_UPDATE,
  QUOTE_STATUS_UPDATE_SUCCESS,
  QUOTE_STATUS_UPDATE_FAIL,
  GET_BY_ID_QUOTES,
  DELETE_QUOTES_RESET,
  ADD_AIR_SHIPMENT_INFO,
  ADD_AIR_SHIPMENT_INFO_FAIL,
  ADD_AIR_SHIPMENT_INFO_LOADER,
  ADD_AIR_SHIPMENT_INFO_SUCCESS,
  GET_AIR_SHIPPER_INFO_BY_ID_FAIL,
  GET_AIR_SHIPPER_INFO_BY_ID_LOADER,
  GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS,
  ADD_SEA_SHIPMENT_INFO,
  ADD_SEA_SHIPMENT_INFO_SUCCESS,
  ADD_SEA_SHIPMENT_INFO_FAIL,
  ADD_SEA_SHIPMENT_INFO_LOADER,
  GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS,
  GET_SEA_SHIPPER_INFO_BY_ID_FAIL,
  GET_SEA_SHIPPER_INFO_BY_ID_LOADER,
  AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL,
  AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS,
  SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL,
  SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER,
  SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS
} from "./actionType"

// Add quotes
const initialState = {
  error: "",
  success: "",
  loading: false,
}

const AddQuotesSeaExportGeneralCargo = (state = initialState, action) => {
  switch (action.type) {
    case ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS:
      state = { ...state, success: action.payload, loading: false, }
      break
    case ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL:
      state = { ...state, error: action.payload, loading: false, }
      break
  }
  return state
}

export default AddQuotesSeaExportGeneralCargo

//Get all quotes
const INITIAL_STATE = {
  quotes: [],
  error: {}
}
export const GetQuotes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ALL_QUOTES_SUCCESS:
      return {
        ...state,
        quotes: action.payload,
      }

    case GET_ALL_QUOTES_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

//Get by id quote
const INITIAL_STATE_Quote = {
  quote: [],
  error: {},
  loading: false,
}
export const GetQuoteById = (state = INITIAL_STATE_Quote, action) => {
  switch (action.type) {
    case GET_BY_ID_QUOTES:
      return {
        ...state,
        loading: true,
      }
    case GET_BY_ID_QUOTES_SUCCESS:
      return {
        ...state,
        quote: action.payload,
        loading: false,
      }

    case GET_BY_ID_QUOTES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    default:
      return state
  }
}

//delete quote
const initialStateDelete = {
  error: "",
  success: "",
  loading: false,
}

export const DeleteQuote = (state = initialStateDelete, action) => {
  switch (action.type) {
    case DELETE_QUOTES:
      state = {
        ...state,
        success: "",
        loading: true,
      }
      break
    case DELETE_QUOTES_SUCCESS:
      state = { ...state, success: action.payload, loading: false, }
      break
    case DELETE_QUOTES_FAIL:
      state = { ...state, error: action.payload, loading: false, }
      break
    case DELETE_QUOTES_RESET:
      state = { success: "", error: '', loading: false, }
      break
  }
  return state
}

//quote status update
const initialStateQuoteStatusUpdate = {
  error: "",
  success: "",
  loading: false,
}

export const QuoteStatusUpdate = (state = initialStateQuoteStatusUpdate, action) => {
  switch (action.type) {
    case QUOTE_STATUS_UPDATE:
      state = {
        ...state,
        loading: true,
      }
      break
    case QUOTE_STATUS_UPDATE_SUCCESS:
      state = { ...state, success: action.payload, loading: false }
      break
    case QUOTE_STATUS_UPDATE_FAIL:
      state = { ...state, error: action.payload, loading: false }
      break
  }
  return state
}

// add air shipper information
const initialStateAddAirShipperInfo = {
  error: "",
  success: "",
  loading: false
}

export const AddAirShipperInfo = (state = initialStateAddAirShipperInfo, action) => {
  switch (action.type) {
    case ADD_AIR_SHIPMENT_INFO:
      state = {
        ...state,
        loading: true
      }
      break
    case ADD_AIR_SHIPMENT_INFO_SUCCESS:
      state = { ...state, success: action.payload, loading: false }
      break
    case ADD_AIR_SHIPMENT_INFO_FAIL:
      state = { ...state, error: action.payload,loading: false }
      break
    case ADD_AIR_SHIPMENT_INFO_LOADER:
      state = {
        ...state,
        loading: action.payload,
      }
  }
  return state
}

//Get Air shipper info by shipper id
const initialStateGetAirShipperInfoById = {
  shipperInfo: [],
  error: '',
  loader: false
}
export const GetAirShipperInfo = (state = initialStateGetAirShipperInfoById, action) => {
  switch (action.type) {
    case GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS:
      return {
        ...state,
        shipperInfo: action.payload,
        loading: false
      }
    case GET_AIR_SHIPPER_INFO_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false
      }
    case GET_AIR_SHIPPER_INFO_BY_ID_LOADER:
      return {
        ...state,
        loader: action.payload,
      }
    default:
      return state
  }
}

// add sea shipper information
const initialStateAddSeaShipperInfo = {
  error: "",
  success: "",
  loading: false
}

export const AddSeaShipperInfo = (state = initialStateAddSeaShipperInfo, action) => {
  switch (action.type) {
    case ADD_SEA_SHIPMENT_INFO:
      state = {
        ...state,
      }
      break
    case ADD_SEA_SHIPMENT_INFO_SUCCESS:
      state = { ...state, success: action.payload,loading: false }
      break
    case ADD_SEA_SHIPMENT_INFO_FAIL:
      state = { ...state, error: action.payload ,loading: false}
      break
    case ADD_SEA_SHIPMENT_INFO_LOADER:
      state = {
        ...state,
        loading: action.payload
      }
  }
  return state
}

//Get sea shipper info by shipper id
const initialStateGetSeaShipperInfoById = {
  shipperInfo: [],
  error: '',
  loader: false
}
export const GetSeaShipperInfo = (state = initialStateGetSeaShipperInfoById, action) => {
  switch (action.type) {
    case GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS:
      return {
        ...state,
        loader: false,
        shipperInfo: action.payload,
      }
    case GET_SEA_SHIPPER_INFO_BY_ID_FAIL:
      return {
        ...state,
        loader: false,
        error: action.payload,
      }
    case GET_SEA_SHIPPER_INFO_BY_ID_LOADER:
      return {
        ...state,
        loader: action.payload,
      }
    default:
      return state
  }
}

//air shipper info status update
const initialStateAirShipperInfoStatusUpdate = {
  error: "",
  success: "",
  loading: false,
}

export const AirShipperInfoStatusUpdate = (state = initialStateAirShipperInfoStatusUpdate, action) => {
  switch (action.type) {
    case AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS:
      state = { ...state, success: action.payload,loading: false }
      break
    case AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL:
      state = { ...state, error: action.payload,loading: false }
      break
    case AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER:
      state = { ...state, error: action.payload }
      break
  }
  return state
}

//air shipper info status update
const initialStateSeaShipperInfoStatusUpdate = {
  error: "",
  success: "",
  loading: false,
}

export const SeaShipperInfoStatusUpdate = (state = initialStateSeaShipperInfoStatusUpdate, action) => {
  switch (action.type) {
    case SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS:
      state = { ...state, success: action.payload, loading: false }
      break
    case SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL:
      state = { ...state, error: action.payload,loading: false }
      break
    case SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER:
      state = { ...state, error: action.payload }
      break
  }
  return state
}